module.exports = __webpack_public_path__ + "static/media/backgroundPic.cb5de4eb.png";